import { Modality, Outcome, Status } from '@/fetching/sharedSchemas/visits';
import { ClinicianAppointmentFilter, ClinicianAppointmentOrdering } from 'gql-types';

import { VisitStateAndOutcomeColors } from './visit';

export namespace ClinicianAppointment {
    export type Filters = ClinicianAppointmentFilter;
    export type Ordering = ClinicianAppointmentOrdering;
}

/*** Clinician Appointment State ***/
export enum ClinicianAppointmentModality {
    MOBILE = 'MOBILE',
    VIRTUAL = 'VIRTUAL',
    CLINIC = 'CLINIC',
}

export const clinicianAppointmentModalityToZod = (
    modality: ClinicianAppointmentModality,
): Modality => {
    switch (modality) {
        case ClinicianAppointmentModality.MOBILE:
            return Modality.Mobile;
        case ClinicianAppointmentModality.VIRTUAL:
            return Modality.Virtual;
        case ClinicianAppointmentModality.CLINIC:
            return Modality.Clinic;
    }
};

export enum ClinicianAppointmentState {
    NOT_STARTED = 'NOT_STARTED',
    EN_ROUTE = 'EN_ROUTE',
    AT_LOCATION = 'AT_LOCATION',
    ENDED = 'ENDED',
}

export enum ClinicianAppointmentOutcome {
    NONE = 'NONE',
    COMPLETED = 'COMPLETED',
    PATIENT_DID_NOT_SHOW = 'PATIENT_DID_NOT_SHOW',
    OTHER = 'OTHER',
}

export const ClinicianAppointmentStateColors: Record<ClinicianAppointmentState, string> = {
    [ClinicianAppointmentState.NOT_STARTED]: VisitStateAndOutcomeColors.GRAY,
    [ClinicianAppointmentState.EN_ROUTE]: VisitStateAndOutcomeColors.ORANGE,
    [ClinicianAppointmentState.AT_LOCATION]: VisitStateAndOutcomeColors.ORANGE,
    [ClinicianAppointmentState.ENDED]: VisitStateAndOutcomeColors.BLUE,
};

export const ClinicianAppointmentOutcomeColors: Record<ClinicianAppointmentOutcome, string> = {
    [ClinicianAppointmentOutcome.NONE]: VisitStateAndOutcomeColors.GRAY,
    [ClinicianAppointmentOutcome.COMPLETED]: VisitStateAndOutcomeColors.BLUE,
    [ClinicianAppointmentOutcome.PATIENT_DID_NOT_SHOW]: VisitStateAndOutcomeColors.RED,
    [ClinicianAppointmentOutcome.OTHER]: VisitStateAndOutcomeColors.RED,
};
export const renderClinicianAppointmentState = (state: ClinicianAppointmentState) => {
    switch (state) {
        case ClinicianAppointmentState.NOT_STARTED:
            return 'Not Started';
        case ClinicianAppointmentState.EN_ROUTE:
            return 'En Route';
        case ClinicianAppointmentState.AT_LOCATION:
            return 'At Location';
        case ClinicianAppointmentState.ENDED:
            return 'Ended';
        default:
            return '';
    }
};

export const clinicianAppointmentStateToZod = (state: ClinicianAppointmentState): Status => {
    return {
        code: state,
        name: renderClinicianAppointmentState(state),
        color: ClinicianAppointmentStateColors[state],
    };
};

export const renderClinicianAppointmentOutcome = (outcome: ClinicianAppointmentOutcome): string => {
    switch (outcome) {
        case ClinicianAppointmentOutcome.NONE:
            return 'None';
        case ClinicianAppointmentOutcome.COMPLETED:
            return 'Completed';
        case ClinicianAppointmentOutcome.PATIENT_DID_NOT_SHOW:
            return 'Patient Did Not Show';
        case ClinicianAppointmentOutcome.OTHER:
            return 'Other';
        default:
            return 'Unknown';
    }
};

export const clinicianAppointmentOutcomeToZod = (outcome: ClinicianAppointmentOutcome): Outcome => {
    return {
        code: outcome,
        name: renderClinicianAppointmentOutcome(outcome),
        color: ClinicianAppointmentOutcomeColors[outcome],
    };
};
